module.exports = __webpack_public_path__ + "static/b1Res1-0d49aacc1c92c29bfa03b4658795c764.png";